<footer class="main-footer">
    <strong>Copyright &copy; {{ today | date:'y'}} <a href="https://valorfinanciamentos.com.br" target="_blank">valorfinanciamentos.com.br</a>.</strong>
    Todos os direitos reservados.
    <div class="float-right d-none d-sm-inline-block">
        <b>v</b> 1.0.0
    </div>
</footer>